import { Box, Typography, Button } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../config/constants';

export const ProGate = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ textAlign: 'center', p: 3, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
      <LockIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1 }} />
      <Typography variant="h6" gutterBottom>AI Review is a Pro Feature</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Upgrade to Pro to get friendly, encouraging feedback on your writing — grammar corrections,
        natural alternatives, and more.
      </Typography>
      <Button variant="contained" onClick={() => navigate(ROUTES.SUBSCRIPTION)}>
        Upgrade to Pro
      </Button>
    </Box>
  );
};
